import { css } from '@mui/material'
import Link from 'next/link'
import CircleExclamationMark from 'assets/icons/circle-exclamation-mark.svg'
import CloseIcon from 'assets/icons/nucleo/18px_xmark.svg'
import { styled } from 'styles/styled'
import { theme } from 'styles/theme'

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
  align-items: center;
  gap: 24px;
  width: 100%;
`
export const ErrorMessageContainer = styled.div`
  margin-top: 8px;
  ${css({ ...theme.typography.bodySRegular })}
  color: ${theme.palette.label.error};
`

export const SignInFlex = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`

export const TitleText = styled.h3`
  padding-top: 12px;
  color: ${theme.palette.label.default};
  text-align: center;
`

export const LogoContainer = styled.div`
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: scale(2.25);
`

export const WarningContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: ${theme.palette.surface.red};
  border-radius: 4px;
  padding: 8px;
  border: 1px solid ${theme.palette.border.focused.error};
`

export const LinkWithoutDecorationFullWidth = styled(Link)`
  text-decoration: none;
  width: 100%;
`

export const CloseAbsoluteDiv = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
`

export const CircleExclamationMarkIcon = styled(CircleExclamationMark)``

export const LogoFormClickableContainer = styled.div`
  width: 24px;
  height: 24px;
  scale: 0.8;
  color: ${theme.palette.label.default};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    path {
      stroke: ${theme.palette.label.subduedDark};
    }
  }
`

export const CloseIconContainer = styled(CloseIcon)`
  scale: 1.2;
  cursor: pointer;
  & path {
    fill: ${theme.palette.label.default};
  }
`
